import { t } from '@lingui/core/macro';
import { BaseLayout } from 'components/Layout/BaseLayout/BaseLayout';
import { NotFound } from 'components/NotFound/NotFound';
import { Helmet } from 'react-helmet';

export const NotFoundPage = () => {
  return (
    <>
      <Helmet>
        <meta
          property="og:description"
          content="404 error. Sorry, that page can't be found."
        />
      </Helmet>
      <BaseLayout pageTitle={t`Not Found | Introducer Portal`}>
        <NotFound />
      </BaseLayout>
    </>
  );
};
